import React from 'react';

function Paperclip(props) {
    const fill = props.fill || 'currentColor';
    const secondaryfill = props.secondaryfill || fill;
    const strokewidth = props.strokewidth || 1;
    const width = props.width || '1em';
    const height = props.height || '1em';

    return (
        <svg height={height} width={width} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g fill="none" stroke={fill} strokeLinecap="round" strokeLinejoin="round" strokeWidth={strokewidth}>
                <path d="M21.44,11.05l-9.19,9.19a6,6,0,0,1-8.49-8.49l9.19-9.19a4,4,0,0,1,5.66,5.66l-9.2,9.19a2,2,0,0,1-2.83-2.83l8.49-8.48" />
            </g>
        </svg>
    );
};

export default Paperclip; 